export const getStatusStages = (statusText) => {
    const statusMap = {
        COMPLETED: { text: 'COMPLETED', color: 'var(--success-color)' },
        REPROVED: { text: 'REPROVED', color: 'var(--error-color)' },
        REPROVED_CLIENT: { text: 'REPROVED_CLIENT', color: 'var(--error-color)' },
        WAITING: { text: 'WAITING_FOR_APPROVAL', color: 'var(--warning-color)' },
        WAITING_CLIENT: { text: 'WAITING_FOR_CLIENTE_APPROVAL', color: 'var(--warning-color)' },
        REJECTED: { text: 'REJECTED', color: 'var(--error-color)' },
    };

    for (const status in statusMap) {
        if (statusMap[status].text === statusText) {
            return statusMap[status];
        }
    }

    return statusMap[status];
};
